import React from "react";
import "./attachment.m.css";

const Attachment = ({ element }) => {
  return (
    <div className="story-element story-element-attachment" styleName="attachment">
      <div styleName="story-element-file__title">{element["file-name"]}</div>
      <a styleName="story-element-file__link" target="_blank" href={element.url} download>
        Preview
      </a>
    </div>
  );
};

export { Attachment };
